import { useEffect, useState } from 'react';

/**
 * Виден ли элемент на экране с учётом обрезки прокручиваемыми предками: элемент, уехавший
 * прокруткой за край своей области, невидим, даже если по координатам он внутри окна браузера.
 *
 * Наблюдение ведётся, только пока `isEnabled` истинно; вне наблюдения элемент считается видимым,
 * чтобы следующее включение не начиналось с устаревшего «не виден».
 */
export const useIsElementVisible = (element: Element | null, isEnabled = true): boolean => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!element || !isEnabled) return;
    const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting));
    observer.observe(element);
    return () => {
      observer.disconnect();
      setIsVisible(true);
    };
  }, [element, isEnabled]);

  return isVisible;
};
